'use strict';

dndNextLevel.regex = /^[a-zA-Z0-9-' ]+$/;

dndNextLevel.styleDefault = ['border-slate-900', 'dark:border-cyan-700'];
dndNextLevel.styleError = ['border-red-500', 'dark:border-red-500', 'bg-red-200', 'border-8'];
dndNextLevel.styleDisabled = ['bg-gray-400', 'hover:bg-red-500'];
dndNextLevel.styleEnabled = ['bg-amber-600', 'hover:bg-amber-500'];
dndNextLevel.openModalId = document.getElementById('openModal');
dndNextLevel.closeModalId = document.getElementById('closeModal');
dndNextLevel.charachterModalId = document.getElementById('character-modal');


dndNextLevel.dndRngNpc.inputValidation = function () {
    dndNextLevel.dndRngNpc.openModal();
    dndNextLevel.dndRngNpc.closeModal();
}

dndNextLevel.dndRngNpc.openModal = function () {
    dndNextLevel.openModalId.addEventListener('click', function () {
        dndNextLevel.charachterModalId.classList.replace('hidden', 'flex');
        dndNextLevel.charachterModalId.addEventListener('click', dndNextLevel.dndRngNpc.closeModalOnOutsideClick);
    });
    dndNextLevel.dndRngNpc.inputChecker();
}

dndNextLevel.dndRngNpc.autoCloseModal = function () {
    dndNextLevel.closeModalId .click();
}

dndNextLevel.dndRngNpc.closeModal = function () {
    dndNextLevel.closeModalId .addEventListener('click', function () {
        dndNextLevel.charachterModalId.classList.replace('flex', 'hidden');
        dndNextLevel.charachterModalId.removeEventListener('click', dndNextLevel.dndRngNpc.closeModalOnOutsideClick);
    });
}

dndNextLevel.dndRngNpc.closeModalOnOutsideClick = function (event) {
    if (event.target === dndNextLevel.charachterModalId) {
        dndNextLevel.charachterModalId.classList.replace('flex', 'hidden');
        dndNextLevel.charachterModalId.removeEventListener('click', dndNextLevel.dndRngNpc.closeModalOnOutsideClick);
    }
    event.stopPropagation();
}

dndNextLevel.dndRngNpc.inputChecker = function () {
    dndNextLevel.dndRngNpc.initValidation('firstname', 'firstname-error');
    dndNextLevel.dndRngNpc.initValidation('lastname', 'lastname-error');
    dndNextLevel.dndRngNpc.initValidation('nickname', 'nickname-error');
    dndNextLevel.dndRngNpc.initValidation('homebrewRace', 'homebrew-error');
    dndNextLevel.dndRngNpc.checkAllFields();
    dndNextLevel.dndRngNpc.toggleRaceSelectOnHomebrewInput();
}

dndNextLevel.dndRngNpc.initValidation = function (inputId, errorId) {
    const input = document.getElementById(inputId);
    const error = document.getElementById(errorId);
    const submitButton = document.getElementById('userInput');

    input.addEventListener('input', () => {
        const value = input.value.trim();
        const isValid = value === "" || dndNextLevel.regex.test(value);

        if (isValid) {
            dndNextLevel.dndRngNpc.applyDefaultStyling(input, error, submitButton);
        } else {
            dndNextLevel.dndRngNpc.applyErrorStyling(input, error, submitButton);
        }
        dndNextLevel.dndRngNpc.checkAllFields();
    });
}

dndNextLevel.dndRngNpc.checkAllFields = function () {
    const fields = ['firstname', 'lastname', 'nickname', 'homebrewRace'];
    const submitButton = document.getElementById('userInput');

    const allValid = fields.every(fieldId => {
        const input = document.getElementById(fieldId);
        const value = input.value.trim();
        return value === "" || dndNextLevel.regex.test(value);
    });

    if (allValid) {
        submitButton.disabled = false;
        submitButton.classList.remove(...dndNextLevel.styleDisabled);
        submitButton.classList.add(...dndNextLevel.styleEnabled);
    } else {
        submitButton.disabled = true;
        submitButton.classList.remove(...dndNextLevel.styleEnabled);
        submitButton.classList.add(...dndNextLevel.styleDisabled);
    }
}

dndNextLevel.dndRngNpc.toggleRaceSelectOnHomebrewInput = function () {
    const homebrewInput = document.getElementById('homebrewRace');
    const raceSelect = document.getElementById('races');

    function toggleFields() {
        if (homebrewInput.value.trim() !== "") {
            raceSelect.disabled = true;
            raceSelect.classList.add('bg-gray-400', 'cursor-not-allowed');
            homebrewInput.classList.remove('bg-gray-400', 'cursor-not-allowed');
        } else {
            raceSelect.disabled = false;
            raceSelect.classList.remove('bg-gray-400', 'cursor-not-allowed');
        }

        if (raceSelect.value !== "") {
            homebrewInput.disabled = true;
            homebrewInput.classList.add('bg-gray-400', 'cursor-not-allowed');
        } else {
            homebrewInput.disabled = false;
            homebrewInput.classList.remove('bg-gray-400', 'cursor-not-allowed');
        }
    }

    homebrewInput.addEventListener('input', toggleFields);
    raceSelect.addEventListener('change', toggleFields);
}



dndNextLevel.dndRngNpc.isVillainBooleanSwitcher = function () {
    const isVillainCheckbox = document.getElementById('check1-61');
    isVillainCheckbox.addEventListener('change', function() {
        if (isVillainCheckbox.checked) {
            dndNextLevel.dndRngNpc.isVillain = !dndNextLevel.dndRngNpc.isVillain;
        } else {
            dndNextLevel.dndRngNpc.isVillain = !dndNextLevel.dndRngNpc.isVillain;
        }
    });
}


dndNextLevel.dndRngNpc.applyDefaultStyling = function (element, error) {
    element.classList.remove(...dndNextLevel.styleError);
    element.classList.add(...dndNextLevel.styleDefault);
    error.classList.add('hidden');
}

dndNextLevel.dndRngNpc.applyErrorStyling = function (element, error) {
    element.classList.remove(...dndNextLevel.styleDefault);
    element.classList.add(...dndNextLevel.styleError);
    error.classList.remove('hidden');
}


dndNextLevel.dndRngNpc.scrollToElement = function () {
    const scrollButtons = document.querySelectorAll(".scroll-to-element");
    dndNextLevel.dndRngNpc.scrollForNavigation(scrollButtons, false);
}

dndNextLevel.dndRngNpc.scrollToModal = function () {
    const scrollButtons = document.querySelectorAll(".scroll-to-modal");
    dndNextLevel.dndRngNpc.scrollForNavigation(scrollButtons, true);
}

dndNextLevel.dndRngNpc.scrollForNavigation = function (scrollButtons, boolean) {
    scrollButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();

            const targetElement = document.getElementById("user-input");
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            } else {
                console.error('Element with id="randomSummon" not found.');
            }
            if (boolean === true) {
                setTimeout(() => {
                    dndNextLevel.openModalId.click();
                }, 850); // 1000 milliseconds = 1 second
            }

        });

    });
}
